import { useNavigate } from "react-router-dom";

const ReturningMembers = () => {
  const navigate = useNavigate();

  return (
    <section id="returning-members" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Header */}
          <div className="mb-6">
            <div className="inline-block bg-purple-600/20 text-purple-400 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              FOR RETURNING STUDENTS ONLY
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Already Trained with <span className="text-purple-400">THE KITCHEN</span>?
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
              If you've taken classes with us before, sign up for the next 3 months and continue your hip-hop journey!
            </p>
          </div>

          {/* Content Card */}
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 md:p-12 max-w-4xl mx-auto border border-gray-700">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              {/* Left Content */}
              <div className="text-left">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Continue Where You Left Off
                </h3>
                <ul className="space-y-3 text-gray-300 mb-6">
                  <li className="flex items-center">
                    <span className="text-purple-400 mr-3">✓</span>
                    Skip the beginner intro - jump right back in
                  </li>
                  <li className="flex items-center">
                    <span className="text-purple-400 mr-3">✓</span>
                    Same instructors you know and love
                  </li>
                  <li className="flex items-center">
                    <span className="text-purple-400 mr-3">✓</span>
                    Build on skills you've already learned
                  </li>
                  <li className="flex items-center">
                    <span className="text-purple-400 mr-3">✓</span>
                    Familiar payment options available
                  </li>
                </ul>
              </div>

              {/* Right Content */}
              <div className="text-center">
                <div className="bg-purple-600/20 rounded-xl p-6 mb-6">
                  <div className="text-4xl font-bold text-purple-400 mb-2">
                    3 Months
                  </div>
                  <div className="text-gray-300">
                    Continue Your Journey
                  </div>
                </div>
                
                <button
                  onClick={() => {
                    navigate("/payment?userType=returning");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                  className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-lg text-xl font-bold transition-all duration-300 transform hover:scale-105 shadow-xl w-full"
                >
                  Continue My Training
                </button>
                
                <p className="text-gray-400 text-sm mt-4">
                  Choose your payment plan on the next page
                </p>
              </div>
            </div>

            {/* Bottom Note */}
            <div className="mt-8 pt-6 border-t border-gray-700">
              <p className="text-gray-400 text-center">
                <span className="text-purple-400 font-semibold">New to THE KITCHEN?</span> 
                {" "}Please use the contact form above to get started with your first class! 💜
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReturningMembers;